import RootStackNavigator from './navigators/RootStackNavigator';

export default RootStackNavigator;
